import React from 'react';

interface TrashProps {
  width?: number;
  color?: string;
}

const Trash = ({ color = '#9498A7' }: TrashProps) => (
  <svg width="15" height="15" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 4V17C16 18.6569 14.6569 20 13 20H6C4.34315 20 3 18.6569 3 17V4"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M7 3V3C7 1.89543 7.89543 1 9 1L10 1C11.1046 1 12 1.89543 12 3V3"
      stroke={color}
      strokeWidth="1.5"
    />
    <line
      x1="0.75"
      y1="3.25"
      x2="18.25"
      y2="3.25"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="11.5"
      y1="16.5"
      x2="11.5"
      y2="6.5"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="7.5"
      y1="16.5"
      x2="7.5"
      y2="6.5"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Trash;
